import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import VerificationForm from "@/components/VerificationForm";
import { Loader2 } from "lucide-react";

const Verification = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userType, setUserType] = useState<string>("");
  const [userId, setUserId] = useState<string>("");

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        navigate("/auth");
        return;
      }

      const { data: profile } = await supabase
        .from("profiles")
        .select("user_type, verification_status")
        .eq("id", session.user.id)
        .single();

      if (profile?.verification_status === "verified") {
        const userType = profile?.user_type;
        const route = userType === "creator" ? "/dashboard/creator/feeds" 
          : userType === "venue" ? "/dashboard/venue/groove-insights" 
          : "/dashboard/groover/feeds";
        navigate(route);
        return;
      }

      setUserType(profile?.user_type || "groover");
      setUserId(session.user.id);
      setLoading(false);
    };

    checkAuth();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  return <VerificationForm userType={userType} userId={userId} />;
};

export default Verification;
